import React from 'react';

const OSD = () => (
	<div class="lg:relative">
	
	<div class="mx-auto w-full pt-16 pb-20 text-center bg-gray-800 lg:py-48 lg:text-left">
	  <div class="px-4 lg:w-1/2 sm:px-8 xl:pr-16">
	  
		<h1 class="text-4xl tracking-tight font-extrabold text-white sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl">
		  <span class="block xl:inline">Same Buttons</span><br/>
		  <span class="block font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-yellow-400 to-orange-600 ">New Tricks</span>
		</h1>
		
		<p class="mt-3 mx-auto text-2xl text-gray-200 sm:text-2xl md:mt-5">
			No new shortcuts to remember. Your brightness keys now go twice as bright as before. Simple as that.
		</p>
		
	  </div>
	</div>
	
	<div class="relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full">
	  <img class="absolute inset-0 w-full h-full object-cover" src="/images/osd.jpeg" alt="" />
	</div>
	
  </div>
	
);
export default OSD;
	
